import { PropsWithChildren } from 'react';
import ReactDOM from 'react-dom';
import { getElementForPortal } from '../../helpers';
import styled from 'styled-components'
import logo from './loader.svg'

type ContainerProps = {
	enabled: boolean
};

const Container = styled.div<ContainerProps>`
	width: 100%;
	height: 100%;
	display: ${(props) => props.enabled ? 'block' : 'none'};
	position: fixed;
	top: 0;
	backdrop-filter: blur(5px);
`;

const Image = styled.img`
	position: absolute;
	top: 45%;
	left: 46%;
	width: 150px;
	transform: translate(-50%, 0);
`;

const Loader = (props: PropsWithChildren<{enabled: boolean}>) => {
	return ReactDOM.createPortal(
		<Container enabled={props.enabled}>
			<Image alt="Laterpay logo" src={logo} />
		</Container>
	, getElementForPortal());
}

export default Loader;
